import {
  Modal,
  Form,
  Input,
  Button,
  Col,
  Row,
  notification,
  Radio,
  DatePicker,
} from "antd";
import { useEffect, useState } from "react";
import store from "../../../../../controllers/store";
import { useSelector } from "react-redux";
import { update } from "../../../../../controllers/store/actions/commons/update-commons-actions";
import SelectCities from "../../Elements/Select-Cities";
import TextArea from "antd/es/input/TextArea";
import SelectAccredited from "../../Elements/Select-Accredited";
import SelectRecognition from "../../Elements/Select-Recognize";
import SelectStates from "../../Elements/Select-States";
import dayjs from "dayjs";
import SelectKnowledgeArea from "../../Elements/Select-Knowledge-Area";
import SelectKnowledgeGran from "../../Elements/Select-Knowledge-Gran";
import SelectKnowledgeSpecialty from "../../Elements/Select-Knowledge-Specialty";
import SelectEntityDependency from "../../Elements/Select-Entity-Dependency";

interface Props {
  loading?: boolean;
  visible: boolean;
  actorType?: any;
  common?: any;
  onUpdated: () => void;
  onCancel: () => void;
}
const dispatch = store.dispatch;

const UpdateCommonModal = (Props: Props) => {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const updatedUniversity = useSelector(
    (state: any) => state.updatedUniversity
  );
  const [state, setState] = useState<any>();
  useEffect(() => {
    form.setFieldsValue({
      ...Props.common,
      update_date: dayjs(Props.common?.update_date),
      issue_date: dayjs(Props.common?.issue_date),
      current_date: dayjs(Props.common?.current_date),
      city: { value: parseFloat(Props.common?.city) },
      state: { value: parseInt(Props.common?.state) },
      dependencie_value: { value: parseInt(Props.common?.dependencie_value) },
      area_de_conocimiento: { value: Props.common?.area_de_conocimiento },
      especialidad_de_conocimiento: {
        value: Props.common?.especialidad_de_conocimiento,
      },
      gran_area_de_conocimiento: {
        value: Props.common?.gran_area_de_conocimiento,
      },
    });
  }, [form, Props.common]);

  return (
    <Modal
      visible={Props.visible}
      width={800}
      title={`${Props?.actorType?.actor || ""}`}
      okText={`Modificar ${Props?.actorType?.actor || ""}`}
      cancelText="Cancelar"
      footer={null}
      onCancel={Props.onCancel}
    >
      <>
        {contextHolder}
        <Form
          form={form}
          layout="vertical"
          onFinish={async (formData: any) => {
            form.validateFields().then(async (values: any) => {
              await dispatch(
                update(Props.common.id, {
                  contact_name: values.contact_name,
                  contact_email: values.contact_email,
                  nombre: values.nombre,
                  universities_entities: [],
                  universities_searchers: [],
                  is_accredited: values.is_accredited,
                  dependencie_type:
                    values.dependencie_value.selectedActor?.type?.id ||
                    Props.common.dependencie_type,
                  dependencie_value: values.dependencie_value.value,
                  external_code: values.external_code,
                  source: values.source,
                  municipality: values.municipality,
                  update_date: new Date(values.update_date).toISOString(),
                  issue_date: new Date(values.issue_date).toISOString(),
                  current_date: new Date(values.current_date).toISOString(),
                  state: values.state.value,
                  description: values.description,
                  sector: values.sector || "",
                  services: values.services || "",
                  actor_type: values.actor_type,
                  recognized_min: values?.recognized_min,
                  features: values.features,
                  city: values.city.value,
                  url: values.url,
                })
              );

              Props.onUpdated();
            });
          }}
          name="updateUniversity"
        >
          <Row gutter={[8, 8]} style={{ width: "100%", marginTop: 30 }}>
            <Col xs={24} sm={12} md={8} lg={18}>
              <Form.Item
                label="Nombre"
                name="nombre"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el nombre de la universidad",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item
                label="Código"
                name="external_code"
                rules={[
                  { required: true, message: "Por favor ingrese el codigo." },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Nombre de contacto"
                name="contact_name"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el nombre del contacto",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Email de contacto"
                name="contact_email"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el email de contacto",
                  },
                  {
                    type: "email",
                    message: "Por favor ingrese un email válido",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={24}>
              <Form.Item
                label="Entidad dependiente"
                name="dependencie_value"
                rules={[{ type: "object" }]}
              >
                <SelectEntityDependency
                  style={{ width: "100%" }}
                  size="large"
                  onChange={async (selected: any) => {
                    if (selected) {
                      setState(selected);
                      form.setFieldValue("dependencie_value", selected);
                    }
                  }}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={12}>
              <Form.Item
                label="Departamento"
                name="state"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectStates
                  style={{ width: "100%" }}
                  size="large"
                  onChange={async (selected: any) => {
                    if (selected) {
                      setState(selected);
                      form.setFieldValue("state", selected);
                      await form.validateFields();
                    }
                  }}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={12}>
              <Form.Item
                label="Ciudad"
                name="city"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectCities
                  selectedState={state?.value}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={async (selected: any) => {
                    if (selected) {
                      form.setFieldValue("city", selected);
                      await form.validateFields();
                    }
                  }}
                  onClear={() => {}}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Area general"
                name="area_de_conocimiento"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeArea
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(value) =>
                    form.setFieldsValue({ area_de_conocimiento: value })
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Área específica"
                name="especialidad_de_conocimiento"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeSpecialty
                  onClear={() => {}}
                  size="large"
                  onChange={(value) =>
                    form.setFieldsValue({
                      especialidad_de_conocimiento: value,
                    })
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Gran área del conocimiento"
                name="gran_area_de_conocimiento"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeGran
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(value) =>
                    form.setFieldsValue({ gran_area_de_conocimiento: value })
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Descripción"
                name="descripcion"
                rules={[{ type: "string" }]}
              >
                <Input.TextArea />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Sector"
                name="sector"
                rules={[{ type: "string" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Servicios ofrecidos"
                name="services"
                rules={[{ type: "string" }]}
              >
                <Input.TextArea />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={12}>
              <Form.Item
                label="Reconocimiento MinCiencia"
                name="recognized_min"
                rules={[
                  {
                    type: "number",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectRecognition
                  onClear={() => {}}
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue("recognized_min", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Fuente"
                name="source"
                rules={[
                  {
                    type: "string",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Características"
                name="features"
                rules={[{ type: "string" }]}
              >
                <TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Fecha de expedición"
                name="issue_date"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "Ingrese una fecha valida",
                  },
                ]}
              >
                <DatePicker
                  placeholder="Fecha de expedición"
                  format={"YYYY-MM-DD"}
                  onChange={(date, dateString) =>
                    form.setFieldValue("issue_date", date)
                  }
                  style={{ width: "100%" }}
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Vigencia"
                name="current_date"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "Ingrese una fecha valida",
                  },
                ]}
              >
                <DatePicker
                  format={"YYYY-MM-DD"}
                  onChange={(date, dateString) =>
                    form.setFieldValue("current_date", date)
                  }
                  style={{ width: "100%" }}
                  size="large"
                  placeholder="Vigencia"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                label="Última actualización"
                name="update_date"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "Ingrese una fecha valida",
                  },
                ]}
              >
                <DatePicker
                  format={"YYYY-MM-DD"}
                  onChange={(date, dateString) =>
                    form.setFieldValue("update_date", date)
                  }
                  style={{ width: "100%" }}
                  size="large"
                  placeholder="Última actualización"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <Form.Item
                label="Página web"
                name="url"
                rules={[{ type: "url" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item wrapperCol={{ span: 24 }}>
            <Button
              loading={updatedUniversity?.isLoading}
              type="primary"
              size={"large"}
              block
              htmlType="submit"
            >
              Modificar {`${Props?.actorType?.actor || ""}`}
            </Button>
          </Form.Item>
        </Form>
      </>
    </Modal>
  );
};
export default UpdateCommonModal;
